<app-table [data]="concepts$ | async" [columns]="columns" [addLink]="'add'" [editLink]="'edit'" (deleteRowEvent)="deleteConcept($event)"></app-table>
<router-outlet></router-outlet>